import React, {useState, useEffect } from 'react';
import styles from './index.scss';
import { Slider } from 'antd';

const Time=()=>{
  const marks = {
    0: {
      style: {
        color: TextGraying(0),
        cursor: ProhibitClick(0),
      },
      label: '00:00',
    },
    // 60: '01:00',
    120: {
      style: {
        color: TextGraying(120),
        cursor: ProhibitClick(120),
      },
      label: '02:00',
    },
    // 180: '03:00',
    240: {
      style: {
        color: TextGraying(240),
        cursor: ProhibitClick(240),
      },
      label: '04:00',
    },
    // 300: '05:00',
    360: {
      style: {
        color: TextGraying(360),
        cursor: ProhibitClick(360),
      },
      label: '06:00',
    },
    // 420: '07:00',
    480: {
      style: {
        color: TextGraying(480),
        cursor: ProhibitClick(480),
      },
      label: '08:00',
    },
    // 540: '09:00',
    600: {
      style: {
        color: TextGraying(600),
        cursor: ProhibitClick(600),
      },
      label: '10:00',
    },
    // 660: '11:00',
    720: {
      style: {
        color: TextGraying(720),
        cursor: ProhibitClick(720),
      },
      label: '12:00',
    },
    // 780: '13:00',
    840: {
      style: {
        color: TextGraying(840),
        cursor: ProhibitClick(840),
      },
      label: '14:00',
    },
    // 900: '15:00',
    960: {
      style: {
        color: TextGraying(960),
        cursor: ProhibitClick(960),
      },
      label: '16:00',
    },
    // 1020: '17:00',
    1080: {
      style: {
        color: TextGraying(1080),
        cursor: ProhibitClick(1080),
      },
      label: '18:00',
    },
    // 1140: '19:00',
    1200: {
      style: {
        color: TextGraying(1200),
        cursor: ProhibitClick(1200),
      },
      label: '20:00',
    },
    // 1260: '21:00',
    1320: {
      style: {
        color: TextGraying(1320),
        cursor: ProhibitClick(1320),
      },
      label: '22:00',
    },
    // 1380: '23:00',
    1440: {
      style: {
        color: TextGraying(1440),
        cursor: ProhibitClick(1440),
      },
      label: '24:00',
    },
  };
  const [InitialTime, setInitialTime] = useState('12:00');

  useEffect(() => {
    setInitialTime(ThisTime()); // 传入当前时间
    let perSecond = setInterval(() => {
      // console.log(321);
    }, 1000);
    return () => {
      clearInterval(perSecond);
    };
  }, []);

  
  function ThisTime() {
    return new Date().getHours() + ':00'; // 获取当前小时
  }
  function TextGraying(data) {
    return parseFloat(tipFormatter(data)) <=
      parseFloat(tipFormatter(ThisTime()))
      ? '#fff'
      : 'pink';
  }
  function ProhibitClick(data) {
    return parseFloat(tipFormatter(data)) <=
      parseFloat(tipFormatter(ThisTime()))
      ? ''
      : 'not-allowed';
  }
  // 时间转换为数值
  function LineConversionTime(currentTimeStr) {
    console.log(currentTimeStr,'val');
    let currentTime = currentTimeStr.split(':');
    if (currentTime.length === 2) {
      return Number(currentTime[0]) * 60 + Number(currentTime[1]);
    } else {
      return 0;
    }
  }
  // 数值转换为时间
  function tipFormatter(NumberOfSteps) {
    if (isNaN(NumberOfSteps)) {
      return NumberOfSteps;
    } else {
      if (
        NumberOfSteps !== '0' &&
        NumberOfSteps !== '' &&
        NumberOfSteps !== null
      ) {
        return (
          (Math.floor(NumberOfSteps / 60).toString().length < 2
            ? '0' + Math.floor(NumberOfSteps / 60).toString()
            : Math.floor(NumberOfSteps / 60).toString()) +
          ':' +
          ((NumberOfSteps % 60).toString().length < 2
            ? '0' + (NumberOfSteps % 60).toString()
            : (NumberOfSteps % 60).toString())
        );
      } else {
        return '';
      }
    }
  }
  // 数值转换为时间
  function onChange(NumericalValue) {
    console.log(NumericalValue,'onChange')
    if (parseFloat(tipFormatter(NumericalValue)) <= parseFloat(ThisTime())) {
      // 字符串转换为数字类型 14:00 => 14
      let CurrentTime = tipFormatter(NumericalValue);
      setInitialTime(CurrentTime);
    } else {
      return null;
    }
  }

  return (
    <div className={styles.container}>
      <Slider
        className={styles.Slider}
        marks={marks}
        min={0}
        max={1440}
        step={1}
        value={LineConversionTime(InitialTime)}
        tooltip={(value) => tipFormatter(value)}
        onChange={(value) => onChange(value)}
        disabled={false}
        defaultValue={90}
      />
    </div>
  );
}

export default Time;
